import { specialFont } from "../../../Infrastructure/Theme/fontFamily";

export const courseListingCardSx = {
  container: {
    borderRadius: 10,
    borderBottom: '3px solid',
    overflow: 'hidden',
    width: { xs: '100%', sm: 312, md: 320, lg: 344 },
  },
  imageBox: {
    borderRadius: '8px 8px 0 0',
    overflow: 'hidden',
    height: 200,
    width: { xs: '100%', sm: 312, md: 320, lg: 344 },
  },
  skeleton: {
    borderRadius: '0px',
    aspectRatio: '16/9',
  },
  contentBox: {
    px: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    wordBreak: 'break-word',
  },
  titleText: {
    fontSize: '16px',
    textTransform: 'capitalize',
    fontFamily: specialFont,
    mt: 2,
  },
  educatorBox: {
    display: 'flex',
    gap: 1,
    cursor: 'pointer',
  },
  educatorName: {
    fontWeight: 700,
    fontSize: '15px',
    textTransform: 'capitalize',
  },
  ratingBox: {
    display: 'flex',
    alignItems: 'center',
  },
  scheduleBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  durationText: {
    fontWeight: 900,
    pt: 1,
    fontSize: '15px',
  },
  costText: {
    fontWeight: 900,
    textAlign: 'center',
    pb: 2,
    pt: 3,
    fontSize: '22px',
  },
  ctaMainBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ctaBox: {
    display: 'flex',
    flexDirection: { sm: 'row', xs: 'column' },
    gap: 2,
  },
  infoText: {
    fontSize: '12px',
    mt: 1,
    display: 'flex',
    alignItems: 'center',
  },
};
